var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('textarea',{attrs:{"id":"editor","rows":"10","cols":"80"}})])
}]

export { render, staticRenderFns }